import { GatherEventEmitter } from "gather-common-including-video/dist/src/public/GatherEventEmitter";
import { GVCInternalWebRTCTransportEvent, } from "./WebRTCTransportEvents";
import { GVCInternalWebSocketEvent, } from "./WebSocketEvents";
import { GVCInternalRouterEvent } from "./RouterEvent";
import { GVCInternalRTCStatsEvent } from "./RTCStatsEvent";
import { GVCInternalConsumerStateEvent } from "./ConumerStateEvents";
import { GVCInternalMediasoupEvent } from "./MediasoupEvents";
export const GVCInternalEvent = {
    ...GVCInternalWebRTCTransportEvent,
    ...GVCInternalWebSocketEvent,
    ...GVCInternalRouterEvent,
    ...GVCInternalRTCStatsEvent,
    ...GVCInternalConsumerStateEvent,
    ...GVCInternalMediasoupEvent,
};
export class GVCEventEmitter extends GatherEventEmitter {
    constructor() {
        super();
    }
    publishWebRTCTransportError(errorCode, context) {
        this.publishEvent(GVCInternalEvent.WebRTCTransportError, errorCode, context);
    }
    publishWebRTCTransportConnectionStateChange(context) {
        this.publishEvent(GVCInternalEvent.WebRTCTransportConnectionStateChange, context);
    }
    publishWebSocketConnectionStateChange(state, context) {
        this.publishEvent(GVCInternalEvent.WebSocketConnectionStateChange, state, context);
    }
}
export const rootEventEmitter = new GVCEventEmitter();
//# sourceMappingURL=GVCEventEmitter.js.map